import Card from "@mui/material/Card";
import MDBox from "components/MDBox";
import { LanguageContext } from "App";
import { useContext } from "react";
import MDTypography from "components/MDTypography";
const PackageStatistics = ({ Package }) => {
  const { translations } = useContext(LanguageContext);

  const getUnqiqueSessionsAndCount = (sessions) => {
    const uniqueSessions = [];
    sessions?.forEach((session) => {
      if (!uniqueSessions.includes(session.sessionName)) {
        uniqueSessions.push(session.sessionName);
      }
    });

    const finalArray = [];
    uniqueSessions?.forEach((sessionName) => {
      const count = sessions.filter((x) => x.sessionName == sessionName).length;
      const sessionId = sessions.filter((x) => x.sessionName == sessionName)[0]
        .sessionId;
      finalArray.push({ Name: sessionName, Count: count, Id: sessionId });
    });

    return finalArray;
  };

  return (
    <Card
      sx={{ height: "100%", boxShadow: !false && "none", marginBottom: "2em" }}
    >
      <MDBox
        pt={2}
        px={2}
        display="flex"
        justifyContent="space-between"
        alignItems="center"
      >
        <MDTypography variant="h6" fontWeight="medium">
          {translations.PackageInfoStatistics}
        </MDTypography>
      </MDBox>

      <MDBox
        mt={3}
        sx={{
          display: "flex",
          flexWrap: "wrap",
          padding: "5rem",
          justifyContent: "center",
          borderBottom: "1px solid #e0e0e0",
        }}
      >
        <MDBox
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: "1em",
            textAlign: "center",
            borderRadius: "1em",
            padding: "1em",
            boxShadow: "0 0 10px 0 rgba(0,0,0,0.2)",
            margin: "4px",
            alignItems: "center",
          }}
        >
          <MDTypography variant="h6" sx={{ fontWeight: "bold" }}>
            {translations.PackageInfoTotalSessions}
          </MDTypography>
          <MDTypography variant="h6" sx={{ fontWeight: "bold" }}>
            {Package?.getAccountingSessions?.length}
          </MDTypography>
        </MDBox>
        <MDBox
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: "1em",
            textAlign: "center",
            borderRadius: "1em",
            padding: "1em",
            boxShadow: "0 0 10px 0 rgba(0,0,0,0.2)",
            margin: "4px",
            alignItems: "center",
          }}
        >
          <MDTypography variant="h6" sx={{ fontWeight: "bold" }}>
            {translations.PackageInfoMadeAppointmen}
          </MDTypography>
          <MDTypography variant="h6" sx={{ fontWeight: "bold" }}>
            {
              Package?.getAccountingSessions?.filter(
                (x) => x.appointmentTime != null
              ).length
            }
          </MDTypography>
        </MDBox>
        <MDBox
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: "1em",
            textAlign: "center",
            borderRadius: "1em",
            padding: "1em",
            boxShadow: "0 0 10px 0 rgba(0,0,0,0.2)",
            margin: "4px",
            alignItems: "center",
          }}
        >
          <MDTypography variant="h6" sx={{ fontWeight: "bold" }}>
            {translations.PackageInfoAdmitted}
          </MDTypography>
          <MDTypography variant="h6" sx={{ fontWeight: "bold" }}>
            {Package?.getAccountingSessions?.filter((x) => x.isAdmitted).length}
          </MDTypography>
        </MDBox>
        <MDBox
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: "1em",
            textAlign: "center",
            borderRadius: "1em",
            padding: "1em",
            boxShadow: "0 0 10px 0 rgba(0,0,0,0.2)",
            margin: "4px",
            alignItems: "center",
          }}
        >
          <MDTypography variant="h6" sx={{ fontWeight: "bold" }}>
            {translations.PackageInfoExceptions}
          </MDTypography>
          <MDTypography variant="h6" sx={{ fontWeight: "bold" }}>
            {
              Package?.getAccountingSessions?.filter((x) => x.isException)
                .length
            }
          </MDTypography>
        </MDBox>
        <MDBox
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: "1em",
            textAlign: "center",
            borderRadius: "1em",
            padding: "1em",
            boxShadow: "0 0 10px 0 rgba(0,0,0,0.2)",
            margin: "4px",
            alignItems: "center",
          }}
        >
          <MDTypography variant="h6" sx={{ fontWeight: "bold" }}>
            {translations.PackageInfoAbsent}
          </MDTypography>
          <MDTypography variant="h6" sx={{ fontWeight: "bold" }}>
            {Package?.getAccountingSessions?.filter((x) => x.isAbsent).length}
          </MDTypography>
        </MDBox>
      </MDBox>
      {/* ************************************************** */}
      <MDBox sx={{ borderBottom: "1px solid #e0e0e0" }}>
        {getUnqiqueSessionsAndCount(Package?.getAccountingSessions)?.map(
          (session, index) => {
            return (
              <div
                key={index}
                className="content"
                style={{
                  display: "flex",
                  flexWrap: "wrap",
                  justifyContent: "center",
                  borderBottom: "1px solid #e0e0e0",
                  padding: "2rem",
                }}
              >
                <MDBox
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "1em",
                    textAlign: "center",
                    margin: "5px",
                    borderRadius: "1em",
                    padding: "1rem 0",
                    boxShadow: "0 0 10px 0 rgba(0,0,0,0.2)",
                    width: "151px",
                    alignItems: "center",
                  }}
                >
                  <MDTypography variant="h6" sx={{ fontWeight: "bold" }}>
                    {session.Name}
                  </MDTypography>

                  <MDTypography variant="h6" sx={{ fontWeight: "bold" }}>
                    {session.Count}
                  </MDTypography>
                </MDBox>
                {/* .......................... */}
                <MDBox
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "1em",
                    textAlign: "center",
                    margin: "5px",
                    borderRadius: "1em",
                    padding: "1rem",
                    boxShadow: "0 0 10px 0 rgba(0,0,0,0.2)",
                  }}
                >
                  <MDTypography variant="h6" sx={{ fontWeight: "bold" }}>
                    {translations.PackageInfoMadeAppointment}
                  </MDTypography>
                  <MDTypography variant="h6" sx={{ fontWeight: "bold" }}>
                    {
                      Package?.getAccountingSessions?.filter(
                        (item) =>
                          item.appointmentTime != null &&
                          item.sessionId == session.Id
                      ).length
                    }
                  </MDTypography>
                </MDBox>

                <MDBox
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "1em",
                    textAlign: "center",
                    margin: "5px",
                    borderRadius: "1em",
                    padding: "1em",
                    boxShadow: "0 0 10px 0 rgba(0,0,0,0.2)",
                  }}
                >
                  <MDTypography variant="h6" sx={{ fontWeight: "bold" }}>
                    {translations.PackageInfoAdmitted}
                  </MDTypography>
                  <MDTypography variant="h6" sx={{ fontWeight: "bold" }}>
                    {
                      Package?.getAccountingSessions?.filter(
                        (item) =>
                          item.isAdmitted && item.sessionId == session.Id
                      ).length
                    }
                  </MDTypography>
                </MDBox>
                <MDBox
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "1em",
                    textAlign: "center",
                    margin: "5px",
                    borderRadius: "1em",
                    padding: "1em",
                    boxShadow: "0 0 10px 0 rgba(0,0,0,0.2)",
                  }}
                >
                  <MDTypography variant="h6" sx={{ fontWeight: "bold" }}>
                    {translations.PackageInfoExceptions}
                  </MDTypography>
                  <MDTypography variant="h6" sx={{ fontWeight: "bold" }}>
                    {
                      Package?.getAccountingSessions?.filter(
                        (item) =>
                          item.isException && item.sessionId == session.Id
                      ).length
                    }
                  </MDTypography>
                </MDBox>
                <MDBox
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "1em",
                    textAlign: "center",
                    margin: "5px",
                    borderRadius: "1em",
                    padding: "1em",
                    boxShadow: "0 0 10px 0 rgba(0,0,0,0.2)",
                  }}
                >
                  <MDTypography variant="h6" sx={{ fontWeight: "bold" }}>
                    {translations.PackageInfoAbsent}
                  </MDTypography>
                  <MDTypography variant="h6" sx={{ fontWeight: "bold" }}>
                    {
                      Package?.getAccountingSessions?.filter(
                        (item) => item.isAbsent && item.sessionId == session.Id
                      ).length
                    }
                  </MDTypography>
                </MDBox>
                {/* ..................... */}
              </div>
            );
          }
        )}
      </MDBox>
    </Card>
  );
};

export default PackageStatistics;
